import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Tilt from "react-parallax-tilt";
import Particle from "../Particle";
import HomeGithubHeatmap from "./HomeGithubHeatmap";

function Home2() {
  return (
    <Container fluid className="home-about-section home2-section" id="about">
      <Particle />
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>A little about me</h1>
            <div className="home-about-body">
              <p className="home-about-lead">
                I&apos;m a full-stack software engineer with a strong focus on
                the frontend—and a real passion for{" "}
                <strong>solving problems</strong>, whether that&apos;s in my day
                job or in products I build on my own time. I like taking messy,
                real-world workflows and turning them into software people can
                actually rely on.
              </p>
              <p className="home-about-lead">
                Outside of work, that same drive shows up in products like{" "}
                <strong>FlipTrac</strong> (multi-tenant SaaS for Texas car
                dealers—inventory, deals, and paperwork) and{" "}
                <strong>HeavyRent</strong> (equipment rental with payments,
                scheduling, and delivery logic). They&apos;re the kind of
                end-to-end problems I enjoy: architecture, tenancy, integrations,
                and shipping something that holds up in production.
              </p>
              <p className="home-about-subhead">How I like to work</p>
              <ul className="home-about-highlights">
                <li>
                  Ship iteratively—clarity and maintainability over clever
                  one-offs
                </li>
                <li>
                  Care about data modeling, auth, and security when products serve
                  many customers
                </li>
                <li>
                  Collaborate across design, product, and backend boundaries
                </li>
                <li>
                  Stay curious: new tools are great when they fit the problem
                </li>
              </ul>
              <p className="home-about-subhead">Skills &amp; tools</p>
              <ul className="home-about-skill-list">
                <li>
                  <span className="purple">Languages:</span> TypeScript,
                  JavaScript, Java, Node.js, Python, C/C++, SQL (PostgreSQL),
                  PHP, HTML, CSS
                </li>
                <li>
                  <span className="purple">Frameworks &amp; runtime:</span>{" "}
                  React, React Native, Angular, Express.js
                </li>
                <li>
                  <span className="purple">Platform &amp; tooling:</span> Git,
                  Docker, AWS, Google Cloud, Azure, Linux, VS Code, IntelliJ,
                  Jira
                </li>
              </ul>
            </div>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
            <div className="home-github-heatmap">
              <span
                className="home-github-wave"
                role="img"
                aria-label="Waving hand"
              >
                👋
              </span>
              <p className="home-github-heatmap-title">GitHub activity</p>
              <HomeGithubHeatmap />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/khanmo97"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-github"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/khan-mohammed-260a26198/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
